import { useSegments } from "expo-router";
import useNavigationGuard from "@/hooks/useNavigationGuard";
import { ActionButton, actionButtonStyles } from "./ActionButton";

export function PinButton() {
  const segs = useSegments();
  const navguard = useNavigationGuard();

  // Only show pin button when segment depth is 4 or less
  if (segs.length > 4) return null;

  return (
    <ActionButton
      icon={navguard.drawerPinned === true ? "pin-off" : "pin"}
      onPress={() => navguard.setDrawerPinned(!navguard.drawerPinned)}
      tooltip={navguard.drawerPinned ? "Unpin" : "Pin"}
      style={actionButtonStyles.iconBtn}
    />
  );
}
